import { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Eye, EyeOff } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (password !== confirm) { setError("Passwords do not match."); return; }
    setError(null);
    setLoading(true);
    try {
      await api.post(`/auth/reset/${token}`, { password });
      toast.success("Password updated. Please sign in.");
      navigate("/auth/sign-in", { replace: true });
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-lv-bg flex items-center justify-center px-6" data-testid="reset-password-page">
      <div className="w-full max-w-sm">
        <div className="text-center mb-10">
          <Link to="/" className="font-serif text-2xl text-cream tracking-[0.25em]">LV PASS</Link>
          <p className="text-xs tracking-[0.3em] uppercase text-lv-muted mt-4">New Password</p>
        </div>
        {error && <div className="mb-6 p-4 border border-lv-inactive/30 bg-lv-inactive/10 text-sand text-sm" data-testid="reset-error">{error}</div>}
        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-lv-muted mb-2" htmlFor="reset-pw">New Password</label>
            <div className="relative">
              <input id="reset-pw" type={showPw ? "text" : "password"} autoComplete="new-password" value={password} onChange={(e) => setPassword(e.target.value)} className="lv-input pr-12" placeholder="Min. 8 characters" required minLength={8} data-testid="reset-password-input" />
              <button type="button" onClick={() => setShowPw(!showPw)} className="absolute right-3 top-1/2 -translate-y-1/2 text-lv-muted hover:text-cream transition-colors min-w-[44px] min-h-[44px] flex items-center justify-center" aria-label="Toggle password visibility">
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div>
            <label className="block text-xs tracking-[0.2em] uppercase text-lv-muted mb-2" htmlFor="reset-confirm">Confirm Password</label>
            <input id="reset-confirm" type="password" autoComplete="new-password" value={confirm} onChange={(e) => setConfirm(e.target.value)} className="lv-input" placeholder="Re-enter password" required data-testid="reset-password-confirm" />
          </div>
          <button type="submit" disabled={loading} className="lv-btn-primary w-full min-h-[48px]" data-testid="reset-password-submit">
            {loading ? "Updating\u2026" : "Reset Password"}
          </button>
        </form>
      </div>
    </div>
  );
}
